import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  content: string;
  content2?: string;
  ackLabel: string;
  ackAction: () => void;
  nackLabel: string;
  nackAction: () => void;
}

export default function ConfirmDialog(props: ConfirmDialogProps) {
  return (
    <Dialog
      open={props.open}
      onClose={props.nackAction}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-content">{props.content}</DialogContentText>
        {props.content2 && (
          <>
            <p></p>
            <DialogContentText id="alert-dialog-content2">{props.content2}</DialogContentText>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.nackAction}>{props.nackLabel}</Button>
        <Button onClick={props.ackAction} autoFocus>
          {props.ackLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
